import * as React from "react";

import type { MenuListProps } from "@fluentui/react-components";
import {
  useMenuList_unstable,
  useMenuListStyles_unstable,
  renderMenuList_unstable,
  useMenuListContextValues_unstable,
} from "@fluentui/react-components";
import { useMenuGroupNavigation } from "../AppMenuItem/useMenuGroupNavigation";
import { useV9MenuEnabled } from "../../hooks/useNextComponentsEnabled";

export const AppMenuList = React.forwardRef<HTMLDivElement, MenuListProps>(
  (props, ref) => {
    const menuGroupNavigation = useMenuGroupNavigation();
    const isV9RibbonMenuEnabled = useV9MenuEnabled();

    const enhancedProps = isV9RibbonMenuEnabled
      ? {
          ...props,
          onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => {
            const handled = menuGroupNavigation.handleKeyDown(event);

            if (!handled && props.onKeyDown) {
              props.onKeyDown(event);
            }
          },
        }
      : props;

    // map to the needed state here. TO-DO
    const state = useMenuList_unstable(enhancedProps, ref);
    const contextValues = useMenuListContextValues_unstable(state);
    useMenuListStyles_unstable(state);
    return renderMenuList_unstable(state, contextValues);
  }
);
